/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Freebies_Headings_SellersInputs */

const id_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual Game Gratis`)
};

const ms_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual Permainan Percuma`)
};

const da_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sælgere af Gratis Spil`)
};

const de_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anbieter kostenloser Spiele`)
};

const en_us2_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Games Sellers`)
};

const es_es2_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedores de juegos gratis`)
};

const es_mx2_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedores de juegos gratis`)
};

const fil_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Nagbebenta ng Libreng Laro`)
};

const fr_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendeurs de jeux gratuits`)
};

const it_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venditori di giochi gratuiti`)
};

const hu_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingyenes játékok eladói`)
};

const nl_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkopers van gratis games`)
};

const no_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selgere av gratis spill`)
};

const pl_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprzedawcy darmowych gier`)
};

const pt_br2_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedores de jogos grátis`)
};

const pt_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedores de jogos grátis`)
};

const ro_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vânzători de jocuri gratuite`)
};

const fi_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaispelien myyjät`)
};

const sv_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säljare av gratis spel`)
};

const vi_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người bán game miễn phí`)
};

const tr_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz Oyun Satıcıları`)
};

const cs_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodejci her zdarma`)
};

const bg_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавачи на безплатни игри`)
};

const ru_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавцы бесплатных игр`)
};

const uk_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавці безкоштовних ігор`)
};

const ar_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بائعي الألعاب المجانية`)
};

const hi_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुफ़्त गेम विक्रेता`)
};

const th_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ขายเกมฟรี`)
};

const ja_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料ゲーム販売元`)
};

const zh_cn2_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费游戏发行商`)
};

const zh_hant1_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費遊戲發行商`)
};

const ko_freebies_headings_sellers = /** @type {(inputs: Freebies_Headings_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 게임 판매자`)
};

/**
* | output |
* | --- |
* | "Free Games Sellers" |
*
* @param {Freebies_Headings_SellersInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const freebies_headings_sellers = /** @type {((inputs?: Freebies_Headings_SellersInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freebies_Headings_SellersInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_freebies_headings_sellers(inputs)
	if (locale === "ms") return ms_freebies_headings_sellers(inputs)
	if (locale === "da") return da_freebies_headings_sellers(inputs)
	if (locale === "de") return de_freebies_headings_sellers(inputs)
	if (locale === "en-US") return en_us2_freebies_headings_sellers(inputs)
	if (locale === "es-ES") return es_es2_freebies_headings_sellers(inputs)
	if (locale === "es-MX") return es_mx2_freebies_headings_sellers(inputs)
	if (locale === "fil") return fil_freebies_headings_sellers(inputs)
	if (locale === "fr") return fr_freebies_headings_sellers(inputs)
	if (locale === "it") return it_freebies_headings_sellers(inputs)
	if (locale === "hu") return hu_freebies_headings_sellers(inputs)
	if (locale === "nl") return nl_freebies_headings_sellers(inputs)
	if (locale === "no") return no_freebies_headings_sellers(inputs)
	if (locale === "pl") return pl_freebies_headings_sellers(inputs)
	if (locale === "pt-BR") return pt_br2_freebies_headings_sellers(inputs)
	if (locale === "pt") return pt_freebies_headings_sellers(inputs)
	if (locale === "ro") return ro_freebies_headings_sellers(inputs)
	if (locale === "fi") return fi_freebies_headings_sellers(inputs)
	if (locale === "sv") return sv_freebies_headings_sellers(inputs)
	if (locale === "vi") return vi_freebies_headings_sellers(inputs)
	if (locale === "tr") return tr_freebies_headings_sellers(inputs)
	if (locale === "cs") return cs_freebies_headings_sellers(inputs)
	if (locale === "bg") return bg_freebies_headings_sellers(inputs)
	if (locale === "ru") return ru_freebies_headings_sellers(inputs)
	if (locale === "uk") return uk_freebies_headings_sellers(inputs)
	if (locale === "ar") return ar_freebies_headings_sellers(inputs)
	if (locale === "hi") return hi_freebies_headings_sellers(inputs)
	if (locale === "th") return th_freebies_headings_sellers(inputs)
	if (locale === "ja") return ja_freebies_headings_sellers(inputs)
	if (locale === "zh-CN") return zh_cn2_freebies_headings_sellers(inputs)
	if (locale === "zh-Hant") return zh_hant1_freebies_headings_sellers(inputs)
	return ko_freebies_headings_sellers(inputs)
});
export { freebies_headings_sellers as "freebies.headings.sellers" }